import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { IStepper } from '@pacifico/interfaces/components.interface';
import { ChannelStepperService } from '@pacifico/services/local/channels/channelStepper.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-stepper',
	templateUrl: './stepper.component.html',
	styleUrls: ['./stepper.component.scss']
})
export class StepperComponent implements OnInit, OnDestroy {
	constructor(private _channelStepperService: ChannelStepperService) {}

	@Input() steps: IStepper[] = [];
	@Input() textButtonSuccess = 'TRANSFERIR';
	@Input() messageTransfer: string | undefined;
	@Input() showBack? = false;
	@Input() showGoToInquiries? = false;
	@Input() styleClass?: string;
	@Input() invertButonColors?: boolean = false;
	@Input() avoidLogicTextButton?: boolean = false;
	@Input() hideButtons = false;
	@Input() disableButton = false;

	@Output() nextClick = new EventEmitter<number>();
	@Output() backClick = new EventEmitter<number>();
	@Output() closeModalEvent: EventEmitter<boolean> = new EventEmitter<boolean>(false);

	currentStep = 0;

	private _subscription!: Subscription;

	ngOnInit(): void {
		this._subscription = this._channelStepperService.$subject.subscribe((data) => {
			if (data) {
				this._next();
			} else if (data === undefined) {
				this._goInit();
			} else {
				this._back();
			}
		});
	}

	ngOnDestroy(): void {
		this._subscription.unsubscribe();
	}

	next(): void {
		this.nextClick.emit(this.currentStep + 1);
	}

	back(): void {
		this.backClick.emit(this.currentStep + 1);
	}

	private _goInit(): void {
		this.currentStep = 0;
		this.backClick.emit(0);
	}

	private _next() {
		if (this.currentStep <= this.steps.length) {
			this.currentStep++;
		}
	}

	private _back() {
		if (this.currentStep > 0) {
			this.currentStep--;
		}
	}

	closeModal(): void {
		this.closeModalEvent.emit(true);
	}
}
